// TODO: fix this
import tabStates from '@enums/tab-states';
import { isNil } from 'lodash';
import promotionDateRangeUtils from '@sharedModules/promotion-date-range-utils';

const { isPromotionDateRangeValid } = promotionDateRangeUtils;

function validateDateTab(
    { scenario, promotion, allowOutsideScenario = false, maxDaysOutsideScenario },
    moment
) {
    if (isNil(promotion.startDate) || isNil(promotion.endDate)) {
        return tabStates.invalid;
    }
    const promoStartDate = moment(promotion.startDate, 'YYYY-MM-DD').utc();
    const promoEndDate = moment(promotion.endDate, 'YYYY-MM-DD').utc();

    if (isNil(scenario)) {
        return promoStartDate && promoEndDate ? tabStates.completed : tabStates.invalid;
    }

    if (
        !isPromotionDateRangeValid({
            promotion,
            scenario,
            allowOutsideScenario,
            maxDaysOutsideScenario,
        })
    ) {
        return tabStates.invalid;
    }

    const scenarioStartDate = moment(scenario.startDate, 'YYYY-MM-DD').utc();
    const scenarioEndDate = moment(scenario.endDate, 'YYYY-MM-DD').utc();

    return scenarioStartDate.isSame(promoStartDate) && scenarioEndDate.isSame(promoEndDate)
        ? tabStates.notStarted
        : tabStates.completed;
}

export default {
    validateDateTab,
};
